/** 이용권 구매 증빙 모달·매출전표 표기용 (서비스 하단 사업자 정보와 동일 출처) */
export const SERVICE_MERCHANT = {
  tradeName: '제이앤조이',
  representative: '정영은',
  bizRegNo: '702-04-02761',
  mailOrderNo: '2024-화성동탄-0316호',
  address: '경기도 화성시 동탄대로시범길 20. 1415동 2701호',
  phone: '010-7442-0199',
  paymentEmail: 'luckytem_mk@naver.com',
} as const;
